import { useWhitelabelConfig } from '@mm/hooks/src/use-whitelabel-config';
import {
  MyLeadsFilterTypes,
  MyLeadsSearchQuery,
} from '@mm/state/interfaces/myLeads';
import { Checkbox, ConfigProvider } from 'antd';
import React from 'react';
import {
  Platform,
  PLATFORMS,
  PLATFORM_CAPTIONS,
} from '../../../Audiences/FilterBar/FilterBarPlatformFilter';
import { useFilterParams } from '../use-filter-params';

type Props = {
  attributeKey: string;
  filterParams: MyLeadsSearchQuery;
  setFilterParams: (params: MyLeadsSearchQuery) => void;
  checkboxDisabled?: boolean;
  css?: {
    checkbox?: string;
    label?: string;
  };
};

export const PlatformsFilter = ({
  attributeKey,
  filterParams,
  setFilterParams,
  checkboxDisabled,
  css,
}: Props) => {
  const { getUpdatedFilterParams, isFilterParamExist } = useFilterParams({
    filterParams,
  });

  const { primaryColor, isWhitelabelCompany } = useWhitelabelConfig();
  const colors = isWhitelabelCompany ? primaryColor : 'var(--color-geekblue-6)';

  const onClick = (platform: Platform) => {
    const updatedQuery = getUpdatedFilterParams({
      key: attributeKey,
      value: platform,
      isExisting: isFilterParamExist({
        key: attributeKey,
        value: platform,
        type: MyLeadsFilterTypes.attributes,
      }),
      type: MyLeadsFilterTypes.attributes,
    });

    setFilterParams(updatedQuery);
  };

  return (
    <>
      {PLATFORMS.map(platform => (
        <ConfigProvider
          theme={{
            components: {
              Checkbox: {
                colorPrimary: colors,
                colorPrimaryHover: colors,
              },
            },
          }}
          key={platform}
        >
          <Checkbox
            className={css?.checkbox}
            checked={isFilterParamExist({
              key: attributeKey,
              value: platform,
              type: MyLeadsFilterTypes.attributes,
            })}
            onClick={() => onClick(platform)}
            name={platform}
            disabled={checkboxDisabled}
          >
            {PLATFORM_CAPTIONS[platform]}{' '}
          </Checkbox>
        </ConfigProvider>
      ))}
    </>
  );
};
